export default "__VITE_ASSET__fc78c6db__"